export default {
  computed: {
    isTopicCategoriesDestination() {
      return this.currentResource.destination === 'topic_categories';
    },
    isTopicsDestination() {
      return this.currentResource.destination === 'topics';
    },
  },
  methods: {
    allCategoryTopicsLoaded(category) {
      return category.counts.total === this.categoryTopics(category).length;
    },
    allCategoryTypeTopicsLoaded(categoryTypeId) {
      let categories = this.$store.getters['categories/all'].filter(c => c.categoryTypeId === categoryTypeId && !c.parentCategoryId);
      let count = categories.map(c => c.counts.total).reduce((a, b) => a + b, 0);
      return count === this.categoryTypeTopics(categoryTypeId).length;
    },
    breadcrumbs(category, topic) {
      let crumbs = [];
      if (this.$route.query.q) {
        crumbs.push({
          name: 'Search',
          route: {
            name: 'search#index',
            query: {
              q: this.$route.query.q,
            },
          },
        });
      }

      if (category) {
        const categories = category.path.split('.').map(id => this.$store.getters['categories/categories'][id]);
        crumbs = categories.filter((c, index) => {
          // if the category has one topic and is the leaf category, don't display it
          // we want categories with a single topic to open straight into the topic
          return c.counts.total > 1 || index !== categories.length - 1;
        }).map(c => {
          return {
            name: c.name,
            route: this.categoryRoute(c),
          };
        });
      }

      if (topic && topic.id) {
        crumbs.push({
          name: topic.assetTitle,
          route: this.topicRoute(topic, category),
        });
      } else if (['search#topic', 'topics#show'].includes(this.$route.name)) {
        // simply adds a placeholder for the breadcrumbs component
        crumbs.push({ name: 'Loading', route: {}});
      }

      return crumbs;
    },
    canAccessTopic(topic) {
      return topic.productAssociations.some(pa => this.$access(this.$store, 'category', pa.categoryId));
    },
    categoryRoute(category) {
      const route = {
        params: {
          categoryId: category.id,
        },
        query: this.currentQuery,
      };

      if (category.counts.total === 1) {
        // Only use topics#show if we have the topics loaded
        const topics = this.categoryTopics(category);
        if (topics.length > 0) {
          route.name = 'topics#show';
          route.params.topicId = topics[0].id;
        } else {
          // Topics not loaded yet, use topics#index and let the component redirect
          route.name = 'topics#index';
        }
      } else {
        route.name = 'topics#index';
      }

      return route;
    },
    categoryTopics(category) {
      const topics = this.$store.getters['topics/root'].filter(t => t.categoryIds.includes(category.id));
      return topics.sort((a, b) => {
        let aPa = a.productAssociations.find(pa => pa.categoryId === category.id);
        let bPa = b.productAssociations.find(pa => pa.categoryId === category.id);
        return aPa.order - bPa.order;
      });
    },
    categoryTypeTopics(categoryTypeId) {
      const ids = this.$store.getters['categories/all'].filter(c => c.categoryTypeId === categoryTypeId).map(c => c.id);
      let topics = this.$store.getters['topics/root'].filter(t => t.categoryIds.some(id => ids.includes(id)));
      topics = topics.sort((a, b) => {
        let aPa = a.productAssociations.find(pa => ids.includes(pa.categoryId));
        let bPa = b.productAssociations.find(pa => ids.includes(pa.categoryId));
        return aPa.order - bPa.order;
      });
      return topics;
    },
    children(topic) {
      const regex = new RegExp(`${topic.id}.\\d+$`);
      return this.$store.getters['topics/all'].filter(t => t.path.match(regex)).sort((a, b) => a.order - b.order);
    },
    descendants(topic) {
      const regex = new RegExp(`${topic.id}.(\\.|\\d)+$`);
      return this.$store.getters['topics/all'].filter(t => t.path.match(regex)).sort((a, b) => a.order - b.order);
    },
    isRoot(topic) {
      return !topic.path.includes('.');
    },
    rootTopic(topic) {
      return this.$store.getters['topics/topics'][topic.path.split('.')[0]];
    },
    showUpsell(topic) {
      if (!this.canAccessTopic(topic)) {
        this.$store.dispatch('ui/toggleUpsellModal', {
          show: true,
          resource: { type: 'category', id: this.category?.id },
          source: { type: 'Locked Topic', value: topic.id },
        });
      }
    },
    topicRoute(topic, category) {
      if (this.canAccessTopic(topic)) {
        const route = {
          name: 'topics#show',
          params: {
            topicId: topic.id,
          },
          query: this.currentQuery,
        };

        if (category) {
          route.params.categoryId = category.id;
        } else {
          route.params.categoryId = 'all';
        }

        return route;
      } else {
        return { query: this.currentQuery };
      }
    },
  },
};
